import { RouteRecordRaw } from 'vue-router'
import { DEFAULT_ROUTE } from '@/config'
import { SystemMode } from '@/types/system'

export default [
  {
    path: '/',
    redirect: DEFAULT_ROUTE,
    component: () => import('@/layout/main/index.vue'),
    children: [
      {
        path: 'home',
        name: 'Home',
        meta: { systemMode: SystemMode.ONLINE_TRAINING },
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: '/secondary',
        name: 'Secondary',
        meta: {},
        component: () => import('@/layout/secondary/index.vue'),
        children: [
          {
            path: 'setting',
            name: 'setting',
            meta: {},
            component: () => import('@/views/setting/index.vue')
          },
          {
            path: 'grade',
            name: 'NewGrade',
            meta: {},
            component: () => import('@/views/grade/index.vue')
          },
          {
            path: 'tower',
            name: 'TowerIdentify',
            meta: {},
            component: () => import('@/views/tower/index.vue')
          },
          {
            path: 'defect-review',
            name: 'DefectReview',
            meta: {},
            component: () => import('@/views/defect-review/index.vue')
          },
          {
            path: 'tutorial-center',
            name: 'TutorialCenter',
            meta: {},
            component: () => import('@/views/tutorialCenter/index.vue')
          },
        ]
      },
      {
        path: '/flight',
        name: 'Flight',
        meta: {},
        component: () => import('@/layout/flight/index.vue'),
        children: [
          {
            path: 'train',
            name: 'Train',
            meta: { systemMode: SystemMode.ONLINE_TRAINING, flightType: 'train' },
            component: () => import('@/views/flight/train/index.vue')
          },
          {
            path: 'passTest',
            name: 'PassTest',
            meta: { systemMode: SystemMode.ONLINE_TRAINING, flightType: 'passTest' },
            component: () => import('@/views/flight/passTest/index.vue')
          },
          {
            path: 'exam',
            name: 'Exam',
            meta: { systemMode: SystemMode.ONLINE_TRAINING, flightType: 'exam' },
            component: () => import('@/views/flight/exam/index.vue')
          },
          {
            path: 'transmit',
            name: 'Transmit',
            meta: { systemMode: SystemMode.ONLINE_TRAINING, flightType: 'transmit' },
            component: () => import('@/views/flight/transmit/index.vue')
          },
          {
            path: 'guide',
            name: 'Guide',
            meta: { systemMode: SystemMode.ONLINE_TRAINING, flightType: 'guide' },
            component: () => import('@/views/flight/guide/index.vue')
          },
          {
            path: 'towerView',
            name: 'TowerView',
            meta: {},
            component: () => import('@/views/tower/tower-view.vue')
          }
        ]
      },
      {
        path: '/admin',
        name: 'Admin',
        meta: {},
        component: () => import('@/views/admin/index.vue')
      }
    ]
  },
  {
    path: '/pilot-assesment',
    name: 'CandidateHome',
    meta: { systemMode: SystemMode.PILOT_ASSESSMENT },
    component: () => import('@/views/candidate/hall/index.vue'),
  },
  {
    path: '/pilot-assesment/exam/:sessionId/subjects',
    name: 'CandidateSubjects',
    meta: { systemMode: SystemMode.PILOT_ASSESSMENT },
    component: () => import('@/views/candidate/subjects/index.vue'),
  },
  {
    path: '/pilot-assesment/exam/:sessionId',
    name: 'CandidateExam',
    meta: { systemMode: SystemMode.PILOT_ASSESSMENT },
    component: () => import('@/views/candidate/exam/index.vue'),
  },
  {
    path: '/pilot-assesment/results',
    name: 'CandidateResults',
    meta: { systemMode: SystemMode.PILOT_ASSESSMENT },
    component: () => import('@/views/candidate/results/index.vue'),
  },
  {
    path: '/pilot-assesment/flight',
    meta: { systemMode: SystemMode.PILOT_ASSESSMENT },
    component: () => import('@/layout/main/index.vue'),
    children: [
      {
        path: '',
        component: () => import('@/layout/flight/index.vue'),
        children: [
          {
            path: 'exam',
            name: 'PilotAssessmentFlightExam',
            meta: { systemMode: SystemMode.PILOT_ASSESSMENT, flightType: 'exam' },
            component: () => import('@/views/flight/exam/index.vue'),
          },
          {
            path: 'transmit',
            name: 'PilotAssessmentFlightTransmit',
            meta: { systemMode: SystemMode.PILOT_ASSESSMENT, flightType: 'transmit' },
            component: () => import('@/views/flight/transmit/index.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/pilot-assesment/candidate/home',
    redirect: { name: 'CandidateHome' },
  },
  {
    path: '/pilot-assesment/candidate/exam/:sessionId/subjects',
    redirect: to => ({
      name: 'CandidateSubjects',
      params: to.params,
      query: to.query,
    }),
  },
  {
    path: '/pilot-assesment/candidate/exam/:sessionId',
    redirect: to => ({
      name: 'CandidateExam',
      params: to.params,
      query: to.query,
    }),
  },
  {
    path: '/pilot-assesment/candidate/results',
    redirect: { name: 'CandidateResults' },
  },
] as RouteRecordRaw[]
